export const initialKiosksState = () => ({
  checkPrinterModeLoading: false,
  checkPrinterModeFailure: false,
  checkPrinterModeLoaded: false,
  kioskTranslateLoading: false,
  kioskTranslateFailure: false,
  kioskTranslateLoaded: false,
});
